<template>
	<div class="addToCart">
		<div class="row align-items-center">
			<div class="col-auto">Quantity:</div>
			<QuantitySelector :step="parseInt(product.pack_size) || 1" :min="parseInt(product.pack_size) || 1" v-model="quantity" class="quantitySelector"/>
			
			
			<div class="col-auto mr-auto">
				<FavouritesButton :itemId="product.id">Add to favourites</FavouritesButton>
			</div>
			<div v-if="product.pack_size && product.pack_size > 1" class="mx-auto">
				This product must be ordered in multiples of {{product.pack_size}}.<br>
				Price shown is for a single unit.
			</div>
		</div>
		<!-- <label>
		Delivery Options:
		<select v-model="deliveryOption">
			<option v-for="option in product.delivery_options" :key="option" :value="option">{{option}}</option>
		</select>
		</label> -->
		<!-- Delivery Options: <br> -->
		<!-- <span v-for="option in product.delivery_options" class="deliveryOption">
		{{option}}
		</span> -->
		<ButtonWithLoading
			@click.native="addToCart"
			text="Add to Cart"
			loadingText="Adding"
			successText="Added Item"
			failureText="Couldn't add item"
			:state="addState"
			class="btn-block my-2"
			:class="(addState == null) ? 'product-add-to-cart-btn' : ''"
			v-if="!requirePrescriptionModal"
		>
			<IconBase>
				<IconCart/>
			</IconBase>
		</ButtonWithLoading>
		<ModalContainerContent v-else>
			<template #modalOpenContent>
				<ButtonWithLoading
					@click.native="showPopover"
					text="Add to Cart"
					loadingText="Adding"
					successText="Added Item"
					failureText="Couldn't add item"
					:state="addState"
					class="btn-block my-2"
				>
					<IconBase>
						<IconCart/>
					</IconBase>
				</ButtonWithLoading>
			</template>
			
			<template #modalHeaderContent>
				You are about to purchase a <br>
				<u>Veterinary Only</u> pet diet product
			</template>

			<template #modalContent>
				<p>Pet prescription/veterinary only diet products are carefully formulated and strictly recommended to be used only under the advice of your pet’s veterinarian. It is strongly recommended that you seek advice from a veterinarian prior to and during feeding this product to your pet, and that you take your pet to your veterinarian regularly (every six months).</p>
				<h4>Declaration Terms & Conditions:</h4>
				<p>I confirm that my pet has been examined by a veterinarian who recommends the use of this product on the basis of his/her diagnosis, and that this product will be used solely as the veterinarian recommends. </p>
				<p>I have also read and understand that, whilst my pet is being fed this product, it is recommended that I seek veterinary advice, at least every six months, regarding the usage of this particular product, and that I need to seek immediate veterinary advice if my pet’s condition deteriorates in any way whilst I use this product.</p>
			</template>

			<template #modalFooterContent>
				<label for="prescriptionCheckbox" class="col-12">
					<input 
						type="checkbox"
						v-model="checked"
						name="prescriptionCheckbox"
						id="prescriptionCheckbox"
						@click="addToCart"
					>
					Please tick to confirm you fully understand and agree to the above Terms & Conditions.
				</label>
			</template>

		</ModalContainerContent>

		<div
			v-if="$store.getters['cart/inCart'](product.id)"
			class="inCart alert alert-success text-center"
		>
			You have {{$store.getters['cart/inCart'](product.id)}} of these in your cart<br>
			<router-link class="btn btn-primary" :to="{name:'cart'}">Go to your cart now</router-link>
		
		</div>
	</div>
</template>

<script>
import ButtonWithLoading from "@/components/buttonWithLoading";
import IconBase from "@/components/iconbase";
import IconCart from "@/components/icons/IconCart.vue";
import { CurrencyFormatter } from "@/utils";
import FavouritesButton from "@/components/buttons/FavouritesButton";

import QuantitySelector from "@/components/QuantitySelector";

// import ProductPopover from "./ProductPopover";

import { mapState, mapGetters } from "vuex";
import ModalContainerContent from "@/components/modal/ModalContainer_Content";

import { makeProductObject } from "@/gaUtils"
// import Modal from "@/components/modal/Modal";

export default {
	name: "ProductPrices",
	components: {
		IconBase,
		IconCart,
		ButtonWithLoading,
		FavouritesButton,
		QuantitySelector,
		ModalContainerContent,
	},
	props: ["product", "source"],
	data() {
		return {
			addState: null,
			quantity: 1,
			deliveryOption: "Home Delivery",
			popoverShowBool: false,
			checked: false,
		};
	},
	created(){
		//set quantity to pack size
		this.quantity = parseInt(this.product.pack_size) || 1;
	},
	methods: {
		CurrencyFormatter,
		addToCart() {
			document.querySelector("body").classList.remove("noscroll")
			this.addState = "loading";
			this.$store
				.dispatch("cart/addItem", {
					productId: this.product.id,
					quantity: this.quantity,
					deliveryOption: this.deliveryOption
				})
				.then(() => {
					//success adding item
					this.addState = "success";
					//send save data to google analytics
					try {
						const products = [makeProductObject(this.product, this.quantity, this.list)]
						const ecommerce = {
							currencyCode: "NZD",
							add: {
								products
							}
						}
						this.$gtm.trackEvent({
							event: "addToCart",
							label: "shop",
							ecommerce
						})
					} catch (error) {
						console.error("Analytics error ", error);
					}
					setTimeout(() => {
						this.addState = null;
						this.quantity = parseInt(this.product.pack_size) || 1;
					}, 1000);
				})
				.catch(error => {
					console.log(error);
					this.addState = "failure";
					setTimeout(() => {
						this.addState = null;
					}, 1000);
				});
		},
		showPopover() {
			this.popoverShowBool = true;
		}
	},
	computed: {
		...mapState({
			memberLevel: state => state.auth.memberLevel
		}),
		...mapGetters({
			// map categories to store.reference.categories
			categoriesMap: "reference/categoriesMap"
		}),
		requirePrescriptionModal() {
			return this.product.veterinary_acknowledgement_required == '1' && !this.checked;
		},
		list() {
			let list = "";
			const cat = this.$router.currentRoute.query.category || null
			const subcat = this.$router.currentRoute.query.subcategory || null
			if (this.source) {
				if (this.source == "search") {
					list = "Search Results"
				}
				if (this.source == "window") {
					list = "Window Shop"
				}
				if (this.source == "specials") {
					list = "Specials"
				}
			} else {
				if(cat && subcat) {
					list = this.categoriesMap[cat].category + "/" + this.categoriesMap[subcat].category
				} else {
					list = "Offsite" 
				}
			}
			return list
		}
	}
};
</script>

<style lang="scss" scoped>
	.quantitySelector{
		margin-top:10px;
		margin-bottom:10px;
	}

	.deliveryOption{
		display:inline-block;
		background:lightgrey;
		margin-top: 10px;
		margin-left:10px;
		padding:2px;

	}
</style>
